<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="keyword" placeholder="请输入bus_app_id" @keyup.enter.native="getUsers"></el-input>
         <el-input v-model="channel_bill_id" placeholder="请输入channel_bill_id"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.bus_app_id }}</span>
        </template>
      </el-table-column>

     <el-table-column label="channel_id" width="">
        <template slot-scope="scope">
          <span>{{scope.row.channel_bill_id}}</span>
        </template>
      </el-table-column>

      <el-table-column label="时间" width="">
        <template slot-scope="scope">
          <span>{{scope.row.created_at | formatDate}}</span>
        </template>
      </el-table-column>

      <el-table-column label="详情" width="">
        <template slot-scope="scope">
         <p v-on:click="requestParams()"><a href="#">查看request_params</a></p>
         <p v-on:click="responseParams()"><a href="#">查看response_params</a></p>
        </template>
      </el-table-column>
      <el-table-column label="status" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹层展示页 -->
    <div class="Change" v-show="isRequestParams" >
       <el-table :data="contracts"  highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="sysCode"
        width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).sysCode}}</span>
        </template>
      </el-table-column>
      <el-table-column label="intfCode" width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).intfCode}}</span>
        </template>
      </el-table-column>

      <el-table-column label="operator" width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).operator}}</span>
        </template>
      </el-table-column>

      <el-table-column label="appId" min-width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).appId}}</span>
        </template>
      </el-table-column>

      <el-table-column label="productId" width="">
        <template slot-scope="scope">
            <span>{{dataFormat(scope.row.request_params).productId}}</span>
        </template>
      </el-table-column>
      <el-table-column label="redPacketAmt" width="">
        <template slot-scope="scope">
            <span>{{dataFormat(scope.row.request_params).redPacketAmt}}</span>
        </template>
      </el-table-column>
      <el-table-column label="redPacketAcct" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).redPacketAcct}}</span>
        </template>
      </el-table-column>
       <el-table-column label="redPacketAcctName" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).redPacketAcctName}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayAcct" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayAcct}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayAcctName" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayAcctName}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayType" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayType}}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    <div class="Change" v-show="isResponseParams" >
       <el-table :data="contracts"  highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="sysCode"
        width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).sysCode}}</span>
        </template>
      </el-table-column>
      <el-table-column label="intfCode" width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).intfCode}}</span>
        </template>
      </el-table-column>

      <el-table-column label="operator" width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).operator}}</span>
        </template>
      </el-table-column>

      <el-table-column label="appId" min-width="">
        <template slot-scope="scope">
         <span>{{dataFormat(scope.row.request_params).appId}}</span>
        </template>
      </el-table-column>

      <el-table-column label="productId" width="">
        <template slot-scope="scope">
            <span>{{dataFormat(scope.row.request_params).productId}}</span>
        </template>
      </el-table-column>
      <el-table-column label="redPacketAmt" width="">
        <template slot-scope="scope">
            <span>{{dataFormat(scope.row.request_params).redPacketAmt}}</span>
        </template>
      </el-table-column>
      <el-table-column label="redPacketAcct" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).redPacketAcct}}</span>
        </template>
      </el-table-column>
       <el-table-column label="redPacketAcctName" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).redPacketAcctName}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayAcct" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayAcct}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayAcctName" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayAcctName}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayType" width="">
        <template slot-scope="scope">
          <span>{{dataFormat(scope.row.request_params).repayType}}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    <!-- 弹层 -->
     <div class="masklayer" id="mask" v-show="mask" style="height: 995px;">
      <span class="cross" v-on:click="cross()">关闭</span>
    </div>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
    import { BusInterestTransferLog } from '../../api/api';
    import { formatDate } from '../../utils/utils.js';
    export default {
      // created() {
      //   this.listLoading = true;
      //   //get list
      //   BusInterestTransferLog()
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },
      // beforeRouteUpdate(to, from, next) {
      //   this.listLoading = true;
      //   //get list
      //   BusInterestTransferLog(to.query)
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },
    
      // 时间转换
      filters: {
        formatDate(time) {
            return formatDate(time, 'yyyy-MM-dd hh:mm');
        }
      },
      data() {
        return {
          keyword: '',
          channel_bill_id:'',
          mask:false,
          isResponseParams:false,
          isRequestParams:false,
          //===有分页会用到
          currentPage: 1,
          listLoading: false,
          total_count: 0,
          pagination: true,
          //=====
           contracts: [],
           dataContent:[]

        }
      },
      methods: {
        // 数据转换
        dataFormat (strdata) {
           return JSON.parse(strdata)
        } ,
        getUsers() {
          let params = {
            'bus_app_id': this.keyword,
            'channel_bill_id': this.channel_bill_id,
             //'page':      this.currentPage
          };
          BusInterestTransferLog(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.transfer_logs
              this.total_count =res.data.transfer_logs.length;
              // if(res.data.total_pages < 2){
              //   this.pagination = false;
              // }else {
              //   this.pagination = true;
              // }
            }
          })
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getUsers();
        },
        requestParams:function(){
         this.mask =! this.mask;
         this.isRequestParams =! this.isRequestParams;
        },
        responseParams:function(){
         this.mask =! this.mask;
         this.isResponseParams =! this.isResponseParams;
        },
         cross:function(){
           this.mask = false;
           this.isResponseParams =false;
           this.isRequestParams =false;
        }
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/BusInterestTransferLog.vue